// src/components/gallery/UploadModal.jsx
import DynamicModal from "../Generic/DynamicModal";
import PhotoUpload from "../PhotoUpload";

const UploadModal = ({ show, onClose, eventName, eventRealName }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
       <><DynamicModal showModal={show} handleClose={onClose} title={`Upload Photos to ${eventRealName}`} body={<PhotoUpload eventName={eventName} />} size="lg" showButtons={false} /></> 
    </div>
  );
};

export default UploadModal;
